import React, { useState, useEffect } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";
import ptBr from '@fullcalendar/core/locales/pt-br';
import { Box, Modal, TextField, Button, MenuItem, Typography, CircularProgress, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close'; // Importação do ícone de fechamento
import DeleteIcon from '@mui/icons-material/Delete'; // Importação do ícone de exclusão
import Header from "../../../components/Header";
import { useAuth } from "../../../components/AuthContext";
import { useNavigate } from "react-router-dom";

const ReporteHoras = () => {
  const { userInfo } = useAuth();
  const navigate = useNavigate();
  const [currentEvents, setCurrentEvents] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [colaboradores, setColaboradores] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [formValues, setFormValues] = useState({
    horas: '',
    horasRestantes: 8,
    descricao: '',
    cliente: '',
    aprovador1: '',
    aprovador2: ''
  });
  const [loading, setLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedEventId, setSelectedEventId] = useState(null); // Para armazenar o ID do evento selecionado
  const colaboradorId = userInfo.id;

  useEffect(() => {
    fetch('https://pf-auditores.ew.r.appspot.com/api/clientes')
      .then(response => response.json())
      .then(data => setClientes(data))
      .catch(error => console.error('Erro ao buscar clientes:', error));
  }, []);

  useEffect(() => {
    fetch('https://pf-auditores.ew.r.appspot.com/api/colaboradores')
      .then(response => response.json())
      .then(data => setColaboradores(data))
      .catch(error => console.error('Erro ao buscar colaboradores:', error));
  }, []);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        if (colaboradorId) { // Verifica se colaboradorId está definido
          const response = await fetch(`https://pf-auditores.ew.r.appspot.com/api/horas-trabalhadas?colaboradorId=${colaboradorId}`);
          const data = await response.json();
          const events = data
            .filter(event => event.colaboradorId === colaboradorId) // Filtra eventos que pertencem ao usuário logado
            .map(event => ({
              id: event.id,
              cliente: event.clienteId,
              title: event.descricao,
              start: event.dia1Data,
              horas: event.totalHoras,
              duration: event.totalHoras,
              end: event.dataFim,
              allDay: true,
            }));

          setCurrentEvents(events); // Atualiza o estado com os eventos filtrados
        }
      } catch (error) {
        console.error('Erro ao buscar eventos:', error);
      }
    };

    fetchEvents();
  }, [colaboradorId]);

  const fetchColaboradores = async (aprovador1, aprovador2) => {
    try {
      const colaborador1Response = await fetch(`https://pf-auditores.ew.r.appspot.com/api/colaboradores/${aprovador1}`);
      const colaborador1 = await colaborador1Response.json();
      const colaborador2Response = await fetch(`https://pf-auditores.ew.r.appspot.com/api/colaboradores/${aprovador2}`);
      const colaborador2 = await colaborador2Response.json();

      setFormValues(prev => ({
        ...prev,
        aprovador1: colaborador1.nome,
        colaborador1: colaborador1.id,
        aprovador2: colaborador2.nome,
        colaborador2: colaborador2.id,
      }));
    } catch (error) {
      console.error('Erro ao buscar colaboradores:', error);
    }
  };

  const handleDateClick = async (info) => {
    setSelectedDate(info);

    const existingHours = currentEvents
      .filter(event => event.start === info.startStr)
      .reduce((total, event) => total + event.horas, 0);

    if (existingHours >= 8) {
      alert("Já foram registradas 8 horas para este dia.");
    } else {
      const hoursRemaining = 8 - existingHours;
      setFormValues(prev => ({
        ...prev,
        horasRestantes: hoursRemaining
      }));
      setModalOpen(true);
    }
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setEditModalOpen(false);
    setFormValues({
      horas: '',
      horasRestantes: 8,
      descricao: '',
      cliente: '',
      aprovador1: '',
      aprovador2: ''
    });
    setSelectedEventId(null); // Limpar o ID do evento selecionado
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    if (name === 'cliente') {
      const cliente = clientes.find(c => c.id === value);
      if (cliente) {
        fetchColaboradores(cliente.aprovador1, cliente.aprovador2);
      }
    }
  
    setFormValues(prev => {
      // Converte o valor para um número
      const inputHoras = Number(value);
  
      // Verifica se o campo 'horas' foi alterado
      if (name === 'horas') {
        // Permite valor vazio enquanto o usuário digita
        if (value === '') {
          return {
            ...prev,
            [name]: '',  // mantém o campo de horas vazio
            horasRestantes: prev.horasRestantes + prev.horas  // restaura o valor original de horas restantes
          };
        }
  
        // Verifica se o valor é negativo ou não numérico
        if (isNaN(inputHoras) || inputHoras <= 0) {
          alert("Por favor, insira um valor positivo para o campo Horas.");
          return prev; // Retorna o estado anterior sem alterações
        }
  
        // Verifica se o valor é maior que o total de horas restantes
        if (inputHoras > prev.horasRestantes + prev.horas) {
          alert("O valor de horas não pode ser maior que o total de horas restantes.");
          return prev; // Retorna o estado anterior sem alterações
        }
  
        // Calcula as horas restantes após a alteração
        const updatedHorasRestantes = prev.horasRestantes + prev.horas - inputHoras;
  
        return {
          ...prev,
          [name]: inputHoras,
          horasRestantes: updatedHorasRestantes
        };
      }
  
      // Para outros campos
      return {
        ...prev,
        [name]: value
      };
    });
  };
  
  
  
  
  
  

  const handleSaveNewEvent = async () => {
    // Verifica se os campos obrigatórios estão preenchidos e se o valor de horas é positivo
    if (formValues.horas && formValues.cliente) {
      // Verifica se o valor de horas é maior que zero
      if (formValues.horas <= 0) {
        alert("Por favor, insira um valor positivo para o campo Horas.");
        return;
      }
  
      setLoading(true);
  
      const newEvent = {
        id: `${selectedDate.dateStr}-${formValues.descricao}`,
        title: formValues.descricao,
        start: selectedDate.startStr,
        end: selectedDate.endStr,
        allDay: selectedDate.allDay,
        estado: "Pendente"
      };
  
      setCurrentEvents(prevEvents => [...prevEvents, newEvent]);
  
      try {
        const response = await fetch('https://pf-auditores.ew.r.appspot.com/api/horas-trabalhadas', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            totalHoras: formValues.horas,
            descricao: formValues.descricao,
            clienteId: formValues.cliente,
            aprovador1: formValues.colaborador1,
            aprovador2: formValues.colaborador2,
            colaboradorId: colaboradorId,
            dia1Data: selectedDate.startStr,
            dataFim: selectedDate.endStr,
            estado: "Pendente"
          })
        });
  
        if (!response.ok) {
          throw new Error('Erro ao salvar os dados.');
        }
  
        const result = await response.json();
        console.log('Dados salvos com sucesso:', result);
        handleCloseModal();
        navigate('/horas');
      } catch (error) {
        console.error('Erro ao salvar os dados:', error);
      } finally {
        setLoading(false);
      }
    } else {
      alert("Por favor, preencha os campos obrigatórios: Cliente e Horas.");
    }
  };
  
  const handleEventClick = async (selected) => {
    const event = selected.event;
    const eventId = event.id;

    setSelectedEventId(eventId); // Armazena o ID do evento selecionado

    try {
        const response = await fetch(`https://pf-auditores.ew.r.appspot.com/api/horas-trabalhadas/${eventId}`);
        if (!response.ok) {
            throw new Error('Erro ao buscar os detalhes do evento');
        }
        const data = await response.json();

        setFormValues({
            horas: data.totalHoras,
            horasRestantes: 8 - data.totalHoras,
            descricao: data.descricao,
            cliente: data.clienteId,
            aprovador1: colaboradores.find(c => c.id === data.aprovador1)?.nome || '',
            aprovador2: colaboradores.find(c => c.id === data.aprovador2)?.nome || ''
        });

        setIsEditing(false); // Define o estado como não editável inicialmente
        setEditModalOpen(true);
    } catch (error) {
        console.error('Erro ao buscar detalhes do evento:', error);
        alert('Não foi possível carregar os detalhes do evento.');
    }
  };

  const handleEdit = async () => {
    if (formValues.horas && formValues.cliente) {
      setLoading(true);
      try {
        const response = await fetch(`https://pf-auditores.ew.r.appspot.com/api/horas-trabalhadas/${selectedEventId}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            totalHoras: formValues.horas,
            descricao: formValues.descricao,
            clienteId: formValues.cliente,
            aprovador1: formValues.colaborador1,
            aprovador2: formValues.colaborador2,
            colaboradorId: colaboradorId,
            dia1Data: selectedDate.startStr,
            dataFim: selectedDate.endStr,
            estado: "Pendente"
          })
        });

        if (!response.ok) {
          throw new Error('Erro ao atualizar os dados.');
        }

        const result = await response.json();
        console.log('Dados atualizados com sucesso:', result);
        handleCloseModal();
        navigate('/horas');
      } catch (error) {
        console.error('Erro ao atualizar os dados:', error);
      } finally {
        setLoading(false);
      }
    } else {
      alert("Por favor, preencha os campos obrigatórios: Cliente e Horas.");
    }
  };

  const handleDelete = async () => {
    if (window.confirm('Você tem certeza que deseja excluir este evento?')) {
      try {
        const response = await fetch(`https://pf-auditores.ew.r.appspot.com/api/horas-trabalhadas/${selectedEventId}`, {
          method: 'DELETE',
        });
  
        if (!response.ok) {
          throw new Error('Erro ao excluir o evento.');
        }
  
        navigate('/horas');
  
        alert('Evento excluído com sucesso.');
      } catch (error) {
        console.error('Erro ao excluir o evento:', error);
        alert('Não foi possível excluir o evento.');
      }
    }
  };

  return (
    <Box m="20px">
      <Header title="Registar Horas" subtitle="Registar horas trabalhadas" />
      <Box display="flex" justifyContent="space-between">
        <Box flex="1 1 100%" ml="15px">
          <FullCalendar
            locale={ptBr}
            height="75vh"
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin]}
            headerToolbar={{
              left: "prev,next today",
              center: "title",
              right: "",
            }}
            initialView="dayGridMonth"
            editable={true}
            selectable={true}
            selectMirror={true}
            dayMaxEvents={true}
            select={handleDateClick}
            eventClick={handleEventClick}
            events={currentEvents}
          />
        </Box>
      </Box>
      
      {/* Modal for Adding New Event */}
      <Modal
        open={modalOpen}
        onClose={handleCloseModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <Box
          p={4}
          bgcolor="white"
          borderRadius={2}
          sx={{ width: '90%', maxWidth: 600, position: 'relative' }} // Adicione posição relativa para o Box
        >
          {/* Botão de fechar no canto superior direito */}
          <IconButton
            onClick={handleCloseModal}
            sx={{ position: 'absolute', top: 8, right: 8 }} // Posiciona o botão no canto superior direito
          >
            <CloseIcon />
          </IconButton>

          <Typography variant="h6" component="h2" id="modal-title">
            Registrar Horas
          </Typography>
          <TextField
            label="Horas"
            name="horas"
            type="text"
            value={formValues.horas}
            onChange={handleChange}
            fullWidth
            margin="normal"
            required
          />
          <TextField
            label="Horas Restantes"
            name="horasRestantes"
            value={formValues.horasRestantes}
            disabled
            fullWidth
            margin="normal"
          />
          <TextField
            label="Descrição"
            name="descricao"
            value={formValues.descricao}
            onChange={handleChange}
            fullWidth
            margin="normal"
            required
            
          />
          <TextField
            label="Cliente"
            name="cliente"
            select
            value={formValues.cliente}
            onChange={handleChange}
            fullWidth
            margin="normal"
            required
            
          >
            {clientes.map((cliente) => (
              <MenuItem key={cliente.id} value={cliente.id}>
                {cliente.nomeCliente}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            label="Aprovador 1"
            name="aprovador1"
            value={formValues.aprovador1}
            disabled
            fullWidth
            margin="normal"
          />
          <TextField
            label="Aprovador 2"
            name="aprovador2"
            value={formValues.aprovador2}
            disabled
            fullWidth
            margin="normal"
          />
          <Box mt={2} display="flex" justifyContent="flex-end">
            <Button 
              onClick={handleSaveNewEvent} 
              color="primary" 
              variant="contained"
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : 'Guardar'}
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Modal for Editing Existing Event */}
      <Modal
        open={editModalOpen}
        onClose={handleCloseModal}
        aria-labelledby="edit-modal-title"
        aria-describedby="edit-modal-description"
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <Box
          p={4}
          bgcolor="white"
          borderRadius={2}
          sx={{ width: '90%', maxWidth: 600, position: 'relative' }} // Adicione posição relativa para o Box
        >
          {/* Botão de fechar no canto superior direito */}
          <IconButton
            onClick={handleCloseModal}
            sx={{ position: 'absolute', top: 8, right: 8 }} // Posiciona o botão no canto superior direito
          >
            <CloseIcon />
          </IconButton>

          <Typography variant="h6" component="h2" id="edit-modal-title">
            Editar Horas
          </Typography>
          <TextField
            label="Horas"
            name="horas"
            type="number"
            value={formValues.horas}
            onChange={handleChange}
            fullWidth
            margin="normal"
            required
            disabled={!isEditing}
          />
          <TextField
            label="Descrição"
            name="descricao"
            value={formValues.descricao}
            onChange={handleChange}
            fullWidth
            margin="normal"
            required
            disabled={!isEditing}
          />
          <TextField
            label="Cliente"
            name="cliente"
            select
            value={formValues.cliente}
            onChange={handleChange}
            fullWidth
            margin="normal"
            required
            disabled={!isEditing}
          >
            {clientes.map((cliente) => (
              <MenuItem key={cliente.id} value={cliente.id}>
                {cliente.nomeCliente}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            label="Aprovador 1"
            name="aprovador1"
            value={formValues.aprovador1}
            disabled
            fullWidth
            margin="normal"
          />
          <TextField
            label="Aprovador 2"
            name="aprovador2"
            value={formValues.aprovador2}
            disabled
            fullWidth
            margin="normal"
          />
          <Box mt={2} display="flex" justifyContent="flex-end">
            <Button 
              onClick={handleDelete} 
              color="error" 
              variant="contained"
              sx={{ ml: 2 }}
            >
              Remover
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default ReporteHoras;
